import { render, staticRenderFns } from "./ModalListFiles.vue?vue&type=template&id=2fc681d0"
import script from "./ModalListFiles.vue?vue&type=script&lang=js"
export * from "./ModalListFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports